<!-- The helper icon. -->
<span class="fas fa-info-circle" *ngIf="isHelptip" [tooltip]="helpText"></span>
<span class="fas fa-info-circle" *ngIf="!isHelptip"></span>

<!-- The helper text. -->
<div class="helper-content" *ngIf="!isHelptip">
    <ng-content></ng-content>
</div>
